define('i19n/strings.en-AU',[],function () {

    ko.validation.localize({
        required: 'This field is required.',
        min: 'Please enter a value greater than or equal to {0}.',
        max: 'Please enter a value less than or equal to {0}.',
        minLength: 'Please enter at least {0} characters.',
        maxLength: 'Please enter no more than {0} characters.',
        pattern: 'Please check this value.',
        step: 'The value must increment by {0}',
        email: 'This is not a valid email address',
        date: 'Please enter a proper date',
        dateISO: 'Please enter a proper date',
        number: 'Please enter a number',
        digit: 'Please enter a digit',
        phoneUS: 'Please specify a valid phone number',
        equal: 'Values must equal',
        notEqual: 'Please choose another value.',
        unique: 'Please make sure the value is unique.'
    });

    return {
        to: {
            initializing: "Initialising"
        }
    };
});
